import { type ReactNode } from 'react';
import { cn } from '../lib/cn';
import { Label } from '../atoms/Label';

export interface FormFieldProps {
  id: string;
  label: string;
  error?: string;
  children: ReactNode;
  className?: string;
}

export function FormField({ id, label, error, children, className }: FormFieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {error && (
        <p id={`${id}-error`} className="text-sm text-priority-critico" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
